import { render, staticRenderFns } from "./SubmissionDetail.vue?vue&type=template&id=f9efa21c&scoped=true"
import script from "./SubmissionDetail.vue?vue&type=script&lang=js"
export * from "./SubmissionDetail.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDetail.vue?vue&type=style&index=0&id=f9efa21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9efa21c",
  null
  
)

export default component.exports